import {
  AffiliateProductCardRating,
  AffiliateProductCardWrapper,
  ProductCardBodyWrapper,
  ProductCardContentWrapper,
  ProductCardCouponWrapper,
  ProductCardHeader,
  ProductCardProductName,
} from '@/app_components/AffiliateProductCard/AffiliateProductCard';
import { Coupon } from '@/app_components/AffiliateProductCard/components/Coupon';
import { ImageCarousel } from '@/app_components/AffiliateProductCard/components/ImageCarousel';
import { ProductCardTabs } from '@/app_components/AffiliateProductCard/components/ProductCardTabs';
import type { AffiliateProductCardProps, ProductCardDataPanelRow } from '@/app_components/AffiliateProductCard/types';
import { Icon } from '@/app_components/common/Icon';
import { Link } from '@/app_components/common/Link';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';

export const AffiliateProductCardDefault = ({ productCard, index }: AffiliateProductCardProps) => {
  const { header, title, body, promotion, cta, images, tabs } = productCard;

  return (
    <AffiliateProductCardWrapper
      featuredProduct={header.featuredProduct}
      layout='default'
    >
      {header.enabled && (
        <ProductCardHeader
          featuredProduct={header.featuredProduct}
          hasTitle={Boolean(header.title)}
        >
          {header.title && <span>{header.title}</span>}
          <AffiliateProductCardRating
            collapsible={true}
            rating={header.rating}
          />
        </ProductCardHeader>
      )}
      <div className='flex p-xs md:p-sm flex-col layout-gap-xs'>
        <ProductCardContentWrapper>
          <div className='flex flex-col gap-xl row-start-2 md:row-start-1 md:col-start-1 min-w-0'>
            <div className='flex flex-col gap-xs'>
              <ProductCardProductName>
                {title.href ? (
                  <Link
                    className='not-prose hover:underline disabled:hover:no-underline aria-disabled:hover:no-underline'
                    href={title.href}
                    recipe='nav'
                    rel='noreferrer noopener'
                    target='_blank'
                    variant='primary'
                  >
                    {title.text}
                  </Link>
                ) : (
                  title.text
                )}
              </ProductCardProductName>
              <ProductCardBodyWrapper>
                {body.enabled &&
                  (body.variant === 1 ? (
                    <p className='typography-default'>{body.content as string}</p>
                  ) : (
                    <div className='flex flex-col'>
                      {(body.content as ProductCardDataPanelRow[]).map((row) => (
                        <div
                          className='flex py-xxs border-b-[1px] stroke-primary justify-between gap-lg items-center self-stretch'
                          key={row.id}
                        >
                          <p className='min-w-[40%]'>{row.label}</p>
                          {row.rowType === 'rating' ? (
                            <AffiliateProductCardRating
                              rating={Number(row.value)}
                              size='small'
                            />
                          ) : (
                            <span className='text-right'>{row.value}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
              </ProductCardBodyWrapper>
            </div>
            <div className='flex flex-col gap-lg'>
              {promotion.enabled && (
                <ProductCardCouponWrapper>
                  <Coupon coupon={promotion} />
                </ProductCardCouponWrapper>
              )}
              <ButtonV2
                className='hover:underline disabled:hover:no-underline aria-disabled:hover:no-underline'
                href={cta.href}
                rel='noreferrer noopener'
                size='lg'
                target='_blank'
                variant='primary'
              >
                {cta.text}
                <Icon
                  className='stroke-white'
                  icon='SquareArrowOutUpRight'
                  mode='custom'
                  size='sm'
                  strokeWidth={1.5}
                />
              </ButtonV2>
            </div>
          </div>
          <div className='row-start-1 md:col-start-2'>
            <ImageCarousel images={images} />
          </div>
        </ProductCardContentWrapper>

        <ProductCardTabs tabs={tabs} />
      </div>
    </AffiliateProductCardWrapper>
  );
};
